// extracted by mini-css-extract-plugin
export default {"title":"Fa7iTK7k"};